import React,{ Component } from "react";


class Modal extends Component {
    
    render() {

        const { id, header, body, footer } = this.props;

        return (<div className="modal fade" 
        id={ id }
        tabIndex="-1" 
        role="dialog" 
        aria-labelledby="clearAllTagsModalTitle" 
        aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="clearAllTagsModalTitle">{ header && header.title }</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                { header && header.component }
              </button>
            </div>
            <div className="modal-body">
             { body }
            </div>
            <div className="modal-footer">
              { footer }
            </div>
          </div>
        </div>
      </div>)
    }
}

export default Modal;
